// Utility to crop image using canvas for react-easy-crop
// https://codesandbox.io/s/react-easy-crop-with-cropped-output-lkh1i?file=/src/cropImage.js
export default function getCroppedImg(file: File, pixelCrop: any): Promise<File> {
  return new Promise((resolve, reject) => {
    const image = new window.Image();
    image.src = URL.createObjectURL(file);
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject();
      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
      );
      canvas.toBlob((blob) => {
        if (!blob) return reject();
        resolve(new File([blob], file.name, { type: file.type }));
      }, file.type);
    };
    image.onerror = reject;
  });
}